/**=========================================================
 * Module: app-zip.js
 * Messages list
 =========================================================*/

 App.directive('appJob', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/job.html',
        restrict: 'E',
        replace: true,
        controller: 'JobController',
        scope: { 
            jid: '=jid',
            type: '@type',
            name: '@name'
          }
    };
  
  });